export const ELASTIC_SEARCH_FIELDS = {
  ORGANIZATION_SEARCH_FIELDS: ['name', 'description', 'parentTenantName'],
  MACHINERY_GROUP_SEARCH_FIELDS: ['name', 'parentName'],
  MACHINE_SEARCH_FIELDS: ['location', 'name', 'category', 'tenant', 'projectId', 'machineTag', 'type'],
  GATEWAY_SEARCH_FIELDS: ['id', 'name', 'cloudplugType', 'machineName', 'tenantName'],
  USER_SEARCH_FIELDS: ['role', 'username', 'displayName', 'parentName', 'machineGroupName'],
  BASE_MENU_SEARCH_FIELDS: ['id', 'name'],
  META_DATA_SEARCH_FIELDS: ['key', 'value', 'updateBy', 'updateTime'],
};